import type { AnyRoute } from "@tanstack/react-router";

import { createRouter } from "@tanstack/react-router";

import DefaultErrorComponent from "./components/DefaultErrorComponent";
import DefaultNotFoundComponent from "./components/DefaultNotFoundComponent";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree: routeTree as AnyRoute,
  defaultPreload: "intent",
  defaultErrorComponent: DefaultErrorComponent,
  defaultNotFoundComponent: DefaultNotFoundComponent,
  defaultPendingComponent: () => null,
});

declare module "@tanstack/react-router" {
  // eslint-disable-next-line ts/consistent-type-definitions -- TanStack Router requires interface augmentation for module declaration merging
  interface Register {
    router: typeof router;
  }
}
